export const ROUTE_PATHS = {
  HOME: '/',
  CORPORATE_CATERING: '/corporate-catering',
  WEDDINGS_EVENTS: '/weddings-events',
  CAFE_SUPPLY: '/cafe-supply',
  BAKERY_DESSERTS: '/bakery-desserts',
  ABOUT: '/about',
  CONTACT: '/contact',
} as const;

export interface Service {
  id: string;
  nameAr: string;
  nameEn: string;
  icon: string;
  descriptionAr: string;
  descriptionEn: string;
  image?: string;
}

export interface Testimonial {
  id: string;
  nameAr: string;
  companyAr: string;
  rating: number;
  quoteAr: string;
  image?: string;
  serviceType: string;
}

export interface GalleryItem {
  id: string;
  image: string;
  titleAr: string;
  category: 'corporate' | 'wedding' | 'cafe' | 'bakery' | 'desserts' | 'coffee';
}

export interface TeamMember {
  id: string;
  nameAr: string;
  roleAr: string;
  image?: string;
}

export interface StatItem {
  value: string;
  labelAr: string;
  icon?: string;
}

export interface WhyUsItem {
  id: string;
  titleAr: string;
  descriptionAr: string;
  icon: string;
  order: number;
}

export interface ClientItem {
  id: string;
  nameAr: string;
  logo?: string;
}
